import React, { useEffect, useState } from "react";
import Header from "../../CommonComponents/header";
import { Footer } from "../../CommonComponents/footer";
import { Img } from "../../subComponents/img";
import { useParams } from "react-router-dom";
import { baseurl } from "../../CommonComponents/baseurl";
import CircularProgress from "@mui/material/CircularProgress";
import Box from "@mui/material/Box";
import { MobileHeader } from "../../CommonComponents/mobileHeader";
import NotFoundComp from "../../CommonComponents/notFoundComp";
import { MainHeading } from "../../subComponents/MainHeading";

const BlogDetailsPage = () => {
  const [blogs, setBlogs] = useState("");
  const [imagealt, setImagealt] = useState("");
  const [isDataLoad, setIsDataLoad] = useState(false);

  const { slug } = useParams();

  useEffect(() => {
    const fetchBlogs = async () => {
      try {
        const formData = new FormData();
        formData.append("slug", slug);

        const response = await fetch(`${baseurl}/api/blog-detail`, {
          method: "POST",
          body: formData,
        });

        const data = await response.json();
        if (data.success === "1") {
          setBlogs(data.data);
        } else {
          console.error("Failed to fetch blog data:", data.message);
        }

        if (data.success === "6") {
          setIsDataLoad(true);
        }
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchBlogs();
  }, [slug]);

  const blogPost = {
    title: blogs.title,
    description: blogs.description,
    status: blogs.status,
    category: blogs.category,
    datetime: blogs.datetime,
    image: blogs.image,
  };

  useEffect(() => {
    if (blogPost.image) {
      var url = blogPost.image.split("/");
      var imagenamelength = url.length;
      var imagename = blogPost.image.split("/")[imagenamelength - 1];
      // console.log(imagename);
      setImagealt(imagename);
    }
  });
  return (
    <>
      <Header />
      <MobileHeader />
      <div className="mobile_spacer"></div>
      <div className="desktop_header_spacer"></div>

      {isDataLoad ? (
        <NotFoundComp />
      ) : (
        <>
          <section className="details_blog_banner">
            <div className="blogs_banner_container">
              {blogPost.image === "" ? (
                <Box sx={{ display: "flex" }}>
                  <CircularProgress style={{ color: "#000", margin: "auto" }} />
                </Box>
              ) : (
                <Img
                  src={blogPost.image}
                  alt={imagealt ?? imagealt}
                  style={{ objectFit: "cover" }}
                  height={"100%"}
                  width={"100%"}
                />
              )}
            </div>
          </section>

          <section className="blog_content_section">
            <MainHeading
              style={{ textTransform: "uppercase", textAlign: "left" }}
              title={blogPost.title}
            />
            <br />
            <p dangerouslySetInnerHTML={{ __html: blogPost.description }}></p>
            <br />
          </section>
        </>
      )}

      <Footer />
    </>
  );
};
export { BlogDetailsPage };
